import { h } from 'maquette'

import Base from './base'

export default class DisableTorch extends Base
  @label: "關手電筒"

  renderFields: =>
    h('div', ['無可用設定'])
